import { getIndexById as _getIndexById, getSectionByPath as _getSectionByPath } from 'app-sections/common/tabs/tabsHelpers';
import { Params } from 'types';

export const SETTINGS_TABS: Params[] = [
  {
    id: '',
    name: 'General',
  },
];

export const getIndexById = (id: string): number => {
  return _getIndexById(id, SETTINGS_TABS);
};

export const getSectionByPath = (path: string): string => {
  return _getSectionByPath(path, 'admin');
};
